var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card-body",
    { staticClass: "cvthemepicker" },
    [
      _c("b-card-title", {
        staticClass: "h5",
        domProps: { innerHTML: _vm._s(_vm.title) },
      }),
      _c("b-card-text", {
        staticClass: "text-muted",
        domProps: { innerHTML: _vm._s(_vm.text) },
      }),
      _c("h6", { staticClass: "font-weight-bold" }, [
        _vm._v(_vm._s(_vm.t.CV_Tool_Color_Theme)),
      ]),
      _c(
        "b-overlay",
        { attrs: { show: _vm.colorLoading === true } },
        _vm._l(_vm.selected.validColorThemes, function (color, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "cvtheme d-flex mb-2",
              class: {
                "colortheme-selected": _vm.selectedColorTheme === color.id,
              },
              on: {
                click: function ($event) {
                  return _vm.selectColorTheme(color.id, true)
                },
              },
            },
            [
              _vm._l(color.hexCodes, function (code, index) {
                return [
                  _c("div", {
                    key: index,
                    staticClass: "cvtheme-color",
                    style:
                      "background:linear-gradient(90deg, rgba(255,255,255,0.3), rgba(0,0,0,0.3)), " +
                      code,
                  }),
                ]
              }),
            ],
            2
          )
        }),
        0
      ),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }